// Статистика по мероприятиям периода: уникальные события (по event.id) по месяцам и в целом за период.
// Многодневное мероприятие = 1 в месяце; пересекшее границу месяца — по 1 в каждом месяце, но 1 в общем итоге.
export function computePlannerStats(grids) {
  const periodIds = new Map();
  const rows = grids.map((grid) => {
    const monthIds = new Map();
    for (const week of grid.weeks) {
      for (const cell of week) {
        if (!cell.inMonth) continue;
        for (const e of cell.events) {
          monthIds.set(e.id, e.status);
          periodIds.set(e.id, e.status);
        }
      }
    }
    const row = { total: 0, approved: 0, drafts: 0 };
    for (const status of monthIds.values()) {
      row.total += 1;
      if (status === 'approved') row.approved += 1;
      else row.drafts += 1;
    }
    return { month: grid.month, year: grid.year, ...row };
  });
  const total = { total: 0, approved: 0, drafts: 0 };
  for (const status of periodIds.values()) {
    total.total += 1;
    if (status === 'approved') total.approved += 1;
    else total.drafts += 1;
  }
  return { rows, total };
}